import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    without: 'Improvisás en la cancha',
    with: 'Tenés un plan táctico'
  }, {
    without: 'Lesiones recurrentes',
    with: 'Cuerpo blindado'
  }, {
    without: 'Te quedás sin físico',
    with: 'Aguantás los 3 sets'
  }, {
    without: 'Te estancás sin saber por qué',
    with: 'Sabés exactamente qué mejorar'
  }, {
    without: 'Te incomodan los zurdos',
    with: 'Dominás ángulos y espacios'
  }, {
    without: 'Te frustrás bajo presión',
    with: 'Foco y control emocional'
  }, {
    without: 'Gastás en paletas nuevas',
    with: 'Invertís en tu juego real'
  }];
  return <div className="w-full max-w-2xl mx-auto my-10 overflow-hidden rounded-xl border border-zinc-800 shadow-2xl" data-id="element-104">
      <div className="grid grid-cols-2 bg-zinc-900 text-center" data-id="element-105">
        <div className="p-3 text-xs md:text-sm font-bold text-[var(--pd-red)] border-b border-r border-zinc-800 flex flex-col items-center justify-center bg-red-950/20 leading-tight" data-id="element-106">
          <X className="w-5 h-5 mb-1" data-id="element-107" />
          Sin Padel 360 Sin Lesiones
        </div>
        <div className="p-3 text-xs md:text-sm font-bold text-[var(--pd-green)] border-b border-zinc-800 flex flex-col items-center justify-center bg-green-950/20 leading-tight" data-id="element-108">
          <Check className="w-5 h-5 mb-1" data-id="element-109" />
          Con Padel 360 Sin Lesiones
        </div>
      </div>

      <div className="bg-black" data-id="element-110">
        {comparisons.map((item, index) => <div key={index} className="grid grid-cols-2 text-sm" data-id="element-111">
            <div className="p-3 border-b border-r border-zinc-800 text-zinc-400 flex items-center gap-2 bg-red-950/10" data-id="element-112">
              <X className="w-4 h-4 text-[var(--pd-red)] flex-shrink-0" data-id="element-113" />
              {item.without}
            </div>
            <div className="p-3 border-b border-zinc-800 text-white font-semibold flex items-center gap-2 bg-green-950/10" data-id="element-114">
              <Check className="w-4 h-4 text-[var(--pd-green)] flex-shrink-0" data-id="element-115" />
              {item.with}
            </div>
          </div>)}
      </div>
    </div>;
}
export function PopUp() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  const names = ['Martín', 'Lucas', 'Facundo', 'Diego', 'Alejandro', 'Juan', 'Matías', 'Nicolás', 'Tomás', 'Gonzalo'];
  const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const intervalTimer = setInterval(showPopup, 35000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-116">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 bg-zinc-900 border border-[var(--pd-green)] rounded-lg shadow-lg p-4 flex items-center gap-4 max-w-sm" data-id="element-117">
          <div className="bg-[var(--pd-green)]/20 p-2 rounded-full" data-id="element-118">
            <Check className="w-6 h-6 text-[var(--pd-green)]" data-id="element-119" />
          </div>
          <div data-id="element-120">
            <p className="text-sm text-white font-medium" data-id="element-121">
              <span className="font-bold text-[var(--pd-green)]" data-id="element-122">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.city}
            </p>
            <p className="text-xs text-zinc-400" data-id="element-123">Acaba de comprar Padel 360</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}